/**
 * Takes an object of keyed React components and returns a sorted array of named components, e.g.
 * {
 *  spot1: { Content: {...}, Children: {...}},
 *  spot2: { Content: {...}, Children: {...}},
 * }
 *
 * @param object: {string: <React.ReactElement>}
 * @returns {<Array of <React.ReactElement>>}
 */
var renderObjectOfComponents = function (object, options) {
    if (options === void 0) { options = {}; }
    if (!object)
        return null;
    if (Array.isArray(object)) {
        /**
        * If current spot is in the new version format (array-like), There's no need to sort .
        * */
        return object;
    }
    var componentList = Object.keys(object);
    componentList.sort();
    return componentList.map(function (component) {
        return object[component] || null;
    });
};
export default renderObjectOfComponents;
